<template>
  <div>
    <topbar
      :titulo="$t('ACADEMICO.IMPRIMIR_RELATORIO_ESTOQUE')"
      :subtitulo="$t('ACADEMICO.IMPRIMIR_RELATORIO_ESTOQUES')"
      :breadcrumbs="breadcrumbs"
    />
    <b-row>
    <b-col cols="3">
      <div
        class="button-select"
        :class="{ selected: estoqueComMovimentacao }"
        @click="selectOption('EstoqueComMovimentacao')"
      >
        <span class="fa-stack fa-2x">
          <i class="fas fa-solid fa-arrow-right-arrow-left fa-stack-1x fa-inverse" style="color: green;"/>
        </span>
        Com movimentação
      </div>
    </b-col>

    <b-col cols="3">
      <div
        class="button-select"
        :class="{ selected: estoqueSemMovimentacao }"
        @click="selectOption('EstoqueSemMovimentacao')"
      >
        <span class="fa-stack fa-2x">
          <i class="fas fa-solid fa-ban fa-stack-1x fa-inverse" style="color: red;"/>
        </span>
        Sem movimentação
      </div>
    </b-col>
  </b-row>
    <b-row v-if="estoqueComMovimentacao || estoqueSemMovimentacao">
      <b-col cols="12" md="3" class="mt-3" v-if="estoqueComMovimentacao">
        <input-date-only-btn
          ref="peridioInicio"
          v-model="selecionados.dataInicio"
          :label="'Período inicio'"
          required
        />
      </b-col>

      <b-col cols="12" md="3" class="mt-3" v-if="estoqueComMovimentacao">
        <input-date-only-btn
          ref="periodoFim"
          v-model="selecionados.dataFim"
          :label="'Período fim'"
          required
        />
      </b-col>

      <b-col cols="12" md="3" class="mt-3">
        <input-select-search
          ref="depositoId"
          v-model="selecionados.depositoId"
          :label="$t(`SUPRIMENTOS.DEPOSITO`)"
          :options="opcoes.depositos"
        />
      </b-col>

      <b-col cols="12" md="auto" class="mt-3">
        <b-button
          class="botao-acao-filtro w-100"
          variant="info"
          @click="realizarImpressaoRelatorioEstoque"
          v-if="podeVisualizar"
        >
          {{ $t('GERAL.GERAR_RELATORIO') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import pdf from '@/common/utils/pdf';
import helpers from '@/common/utils/helpers';
import mensagem from '@/common/utils/mensagem';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import EstoqueService from '@/common/services/estoque/estoque.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import DepositoService from '@/common/services/depositos/depositos.service';

// Components:
import {
  InputDateOnlyBtn,
  InputSelectSearch,
} from '@/components/inputs';

export default {
  mixins: [Permissoes],
  components: {
    InputDateOnlyBtn,
    InputSelectSearch,
    Topbar,
  },

  template: {},
  data() {
    return {
      selectedOption: null,
      breadcrumbs: [
        { titulo: this.$t('SUPRIMENTOS.SUPRIMENTOS') },
        { titulo: this.$t('MENU.RELATORIO_ESTOQUE') },
      ],
      selecionados: {},
      relatorioEstoqueLayoutDados: null,
      opcoes: {
        estoqueLayout: [],
        depositos: [],
      },
    };
  },
  mounted() {
    this.getEstoquelayout();
    this.getDepositos();
  },
  methods: {
    selectOption(option) {
      this.selecionados = {};
      this.relatorioEstoqueLayoutDados = option; // Atualiza a seleção
    },
    getDepositos() {
      this.$store.dispatch(START_LOADING);
      DepositoService.obterTodos()
        .then(({ data }) => {
          this.opcoes.depositos = data.itens.map((deposito) => ({
            depositoNovoId: deposito.id,
            text: deposito.descricao,
            value: deposito.id,
          }));
        })
        .catch(({ error }) => {
          mensagem.erro(this.$t('GERAL.ERRO'), error.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFormulario() {
      if (this.selecionados.periodoFim < this.selecionados.periodoInicial) {
        mensagem.erro(
          this.$t('GERAL.ERRO'),
          this.$t('ACADEMICO.DATAS_INVALIDAS')
        );
        return;
      }
      return helpers.validarFormulario(this.$refs);
    },
    realizarImpressaoRelatorioEstoque() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);

      this.selecionados.relatorioEstoqueLayout = this.estoqueComMovimentacao ? 'EstoqueComMovimentacao' : 'EstoqueSemMovimentacao';

      EstoqueService.obterRelatorioEstoque(this.selecionados)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);

            let blob = new Blob([bytes], { type: 'application/pdf' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getEstoquelayout() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('estoque-layout')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.estoqueLayout = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  computed: {
    estoqueComMovimentacao() {
      return this.relatorioEstoqueLayoutDados === 'EstoqueComMovimentacao'
    },
    estoqueSemMovimentacao() {
      return this.relatorioEstoqueLayoutDados === 'EstoqueSemMovimentacao'
    }
  }
};
</script>

<style>
.ajuste-fino-btn {
  margin-top: 29px;
}
.button-select {
  display: flex;
  font-weight: bold;
  font-size: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 15vh;
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  transition: border-color 0.3s ease;
}

.button-select:hover {
  border-color: #888;
}

.selected {
  border: 2px solid blue;
}

.fa-stack {
  display: inline-block;
  position: relative;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}
</style>
